import { put, takeLatest, call } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'
import { getCandidateNotes, postCandidateNote, patchCandidateNote, deleteCandidateNote } from '@/core/apiModules/candidateNotes'
import { notesModule } from '../modules'
import { errorHandler } from '@/core/helpers/errorHelpers'

function* fetchSaga({ payload }) {
  try {
    yield put(notesModule.toggleLoading(true))
    const response = yield call(getCandidateNotes, payload.hiring_team_id, payload.params)
    yield put(notesModule.fetchSuccess(response))
    yield put(notesModule.toggleLoading(false))
  } catch (err) {
    yield call(errorHandler, err)
  }
}

function* createSaga({ meta }) {
  try {
    const response = yield call(postCandidateNote, meta.hiring_team_id, meta.data)
    yield put(notesModule.createSuccess(response))
    yield call(meta.formResolve)
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield call(meta.formReject, new SubmissionError({ _error: error }))
  }
}

function* updateSaga({ payload, meta }) {
  try {
    yield put(notesModule.toggleUpdating(true))
    const response = yield call(patchCandidateNote, payload.hiring_team_id, payload.note_id, payload.data)
    yield put(notesModule.updateNoteSuccess(response))
    yield put(notesModule.toggleUpdating(false))
    yield call(meta.formResolve)
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield call(meta.formReject, new SubmissionError({ _error: error }))
  }
}

function* deleteSaga({ payload }) {
  try {
    yield put(notesModule.toggleDeleting(true))
    yield call(deleteCandidateNote, payload.hiring_team_id, payload.note_id)
    yield put(notesModule.deleteNoteSuccess({ noteId: payload.note_id }))
    yield put(notesModule.toggleDeleting(false))
  } catch (err) {
    yield call(errorHandler, err)
  }
}

export default function* watchNotesSaga() {
  yield takeLatest(notesModule.FETCH, fetchSaga)
  yield takeLatest(notesModule.CREATE, createSaga)
  yield takeLatest(notesModule.UPDATE_NOTE, updateSaga)
  yield takeLatest(notesModule.DELETE_NOTE, deleteSaga)
}
